import { Modal } from "antd";
import { message } from "utils/ciq-message";
import { ProjectContext } from "context/ProjectProvider";
import { useContext, useState } from "react";
import { MUTATION_UPDATE_TRACKING } from "../queries/mutation";
import { useCIQMutation } from "hooks/ciq-gql-hooks";

type MoveTrackedSubmittalModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  featureInstances: any[];
};

function MoveTrackedSubmittalModal({
  open,
  onClose,
  onSuccess,
  featureInstances
}: MoveTrackedSubmittalModalProps) {
  const [loading, setLoading] = useState(false);
  const { gqlClientForProject } = useContext(ProjectContext);

  const [updateTrackingMutation] = useCIQMutation(MUTATION_UPDATE_TRACKING, {
    client: gqlClientForProject
  });

  const handleStartTracking = async () => {
    if (!featureInstances.length) return;
    setLoading(true);
    const featureInstanceIds = featureInstances.map((instance) => instance.id);
    const response = await updateTrackingMutation({
      variables: {
        featureInstanceIds,
        isTracked: true
      }
    });

    if (response.data?.update_feature_tracking) {
      message.success(
        "Submittal added back to the Log for planning and tracking."
      );
      onSuccess();
    } else {
      message.error(
        "Failed to add submittal back to the Log for planning and tracking."
      );
    }
    setLoading(false);
  };

  return (
    <Modal
      title="Track This Submittal?"
      open={open}
      onCancel={onClose}
      onOk={handleStartTracking}
      okText="Confirm"
      cancelText="Cancel"
      okButtonProps={{ loading: loading, disabled: loading }}
      cancelButtonProps={{ disabled: loading }}
      mask={{ closable: !loading }}
      destroyOnHidden
      width={450}
      data-testid="index-modal-move-tracked-submittal"
    >
      <p className="m-0">
        {featureInstances.length === 1
          ? "This Submittal will be moved to the Submittal Log. Link the Submittal to "
          : "These Submittals will be moved to the Submittal Log. Link the Submittals to "}
        resume planning and tracking.
      </p>
    </Modal>
  );
}

export default MoveTrackedSubmittalModal;
